module.exports = __webpack_public_path__ + "static/media/logo.d6f20ff7.svg";